export default {
  home: "Accueil",
  aboutUs: "À propos de nous",
  capabilities: "Capacités",
  esg: "Durabilité",
  careers: "Carrières",
  contact: "Contact",
  ourJourney: "Notre parcours",
  visionMission: "Vision et mission",
  leadershipTeam: "Équipe dirigeante",
};

